import React from 'react'
import AdminActivityLogComponent from '../../Components/adminActivityLogComponent'
import Aside from '../../Components/aside'
import TopBar from '../../Components/topBar'

const Activitylog = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminActivityLogComponent/>
      </div>
    </div>
    
  )
}

export default Activitylog